<template>
  <div class="appContent">
    <h1 class="appContent__title">{{ $t('pageNames.' + $route.name) }}</h1>
    <app-header-card />
    <div class="appContent__content">
      <router-view />
    </div>
  </div>
</template>

<script>
import AppHeaderCard from '@/components/layout/AppHeaderCard'

export default {
  name: "AppContent",
  components: {
    AppHeaderCard
  }
}
</script>

<style lang="scss" scoped>
$c: '.appContent';

#{$c} {
  margin-bottom: 40px;
  min-height: calc(100vh - 101px - 84px - 40px - 10px);

  &__title {
    padding: 0 $--base-padding;
    margin: 10px 0;
    @include respond-below(sm) {
      padding: 0 $--base-padding-sm;
      margin-left: 16px;
    }
  }
  &__content {
    padding: 0 $--base-padding;
    @include respond-below(sm) {
      padding: 0 $--base-padding-sm;
    }
  }
}
</style>